import { LicenseEventBase } from './licenseEventBase';

const eventSubType = 'Trial Granted';

export class TrialGrantedEvent extends LicenseEventBase<{
  eventSubType: typeof eventSubType;
  itemNumber: string;
  userEmail: string;
  curriculum?: {
    brandCode: string;
    ageCategory: string;
  };
}> {
  get eventSubType(): typeof eventSubType {
    return eventSubType;
  }
}
